import { call, put } from 'redux-saga/effects';
import { getQueryParams } from 'functions/urlHelpers';
import { QUERY_PARAMS } from 'consts/queryParams';
import { processMarketingParams } from 'functions/marketingParams';
import { ITEMS } from 'consts/localStorage';
import createGuestUser from 'functions/authentication/createGuestUser';
import CConsole from 'functions/CConsole';
import sendRollbarError from 'functions/sendRollbarError';
import { getCookieValue } from 'functions/cookies';
import { COOKIES } from 'consts/cookies';
import * as userActions from '../actions';

function* initDemoFlowHandler() {
  const { token, uidToken, xuid } = getQueryParams([QUERY_PARAMS.token, QUERY_PARAMS.uidToken, QUERY_PARAMS.xuid]);

  try {
    yield call(processMarketingParams);

    if (token && uidToken) {
      yield put(
        userActions.loginWithToken({
          data: { t: token, ut: uidToken },
        }),
      );

      return;
    }

    if (xuid) {
      localStorage.setItem(ITEMS.xuid, xuid);
    }

    if (!getCookieValue(COOKIES.logged)) {
      yield call(createGuestUser);
    }

    if (window.location.href.includes('https://www.karmanow.com')) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  } catch (error) {
    CConsole.error(error);
    sendRollbarError('initDemoFlowHandler issue', { error });
  } finally {
    yield put(userActions.fetchUser());
  }
}

export default initDemoFlowHandler;
